import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { strongEmLink } from '../../../data/richText'

export default defineType({
  name: 'realPerformancePage',
  title: 'Real performance',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    // TODO: consider if it's worth adding `realPerformance` as a component or keep individual fields
    // due to h1 for the page in context of a page block vs a single page
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Leading text',
      name: 'leadingText',
      type: 'array',
      of: strongEmLink,
      group: 'content',
    }),
    defineField({
      title: 'YouTube Video',
      name: 'youtubeVideo',
      type: 'youtubeVideo',
      group: 'content',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
      group: 'content',
    }),
    defineField({
      title: 'Myths',
      name: 'myths',
      type: 'myths',
      group: 'content',
    }),
    /* ************************************************************
    Related articles section
    ************************************************************ */
    defineField({
      title: 'Blog',
      name: 'blog',
      type: 'object',
      fields: [
        defineField({
          title: 'Section title',
          name: 'title',
          type: 'string',
        }),
        defineField({
          title: 'Lead',
          name: 'lead',
          type: 'string',
        }),
        defineField({
          title: 'Articles',
          name: 'articles',
          type: 'array',
          of: [
            {
              type: 'reference',
              to: [{ type: 'article' }],
              options: {
                filter: `showOnRealPerformancePage`,
              },
            },
          ],
          validation: (rule) => [
            rule.unique().error('Each article should be unique'),
          ],
        }),
        defineField({
          title: 'Button list',
          name: 'buttonList',
          type: 'buttonList',
        }),
      ],
      group: 'content',
    }),

    /* ************************************************************
    Hero section
    TODO: consider reworking this, for now it can stay as is
    ************************************************************ */
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'hero',
      group: 'content',
    }),

    getPageInfo({ lockCanonical: true }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title,
        subtitle: 'Real Performance Page',
      }
    },
  },
})